import { ScrollStrategy, ScrollStrategyOptions } from '@angular/cdk/overlay';
import { NgClass, formatDate, isPlatformBrowser } from '@angular/common';
import { Component, Inject, Input, OnDestroy, OnInit, PLATFORM_ID, TemplateRef, ViewChild, ɵDEFAULT_LOCALE_ID } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { environment } from '../../_environments/environment';
import { CustomerLifestyle } from '../../_model/customer';
import { Recipe } from '../../_model/recipe';
import { AuthService } from '../../_service/AuthService';
import { CustomerService } from '../../_service/CustomerService';
import { DrawerIdentifier, DrawerService, Drawerposition } from '../../_service/DrawerService';
import { GlobalService } from '../../_service/GlobalService';
import { SubscriptionService } from '../../_service/SubscriptionService';
import { FaqComponent } from '../faq/faq.component';
import { ImageComponent } from '../image/image.component';
import { LifestylechosendialogComponent } from '../lifestylechosendialog/lifestylechosendialog.component';
import { RecipeComponent } from '../recipe/recipe.component';
import { RecipecardComponent } from '../recipecard/recipecard.component';
import { RecipelistComponent } from '../recipelist/recipelist.component';
import { SafeHtmlPipe } from '../pipe/safe-html.pipe';
import { OverlayComponent } from 'src/orderflowModule/overlay/overlay.component';
import { PersonselectionComponent } from "../personselection/personselection.component";
import { QuantityselectionComponent } from "../quantityselection/quantityselection.component";


@Component({
    selector: 'app-lifestyle',
    templateUrl: './lifestyle.component.html',
    styleUrls: ['./lifestyle.component.scss'],
    imports: [
        NgClass,
        SafeHtmlPipe,
        ImageComponent, FaqComponent, RecipelistComponent, RecipecardComponent, LifestylechosendialogComponent,
        TranslateModule,
        PersonselectionComponent,
        QuantityselectionComponent
    ]
})
export class LifestyleComponent implements OnInit, OnDestroy {

  _env = environment;

  _lifestyle: any; // Lifestyle
  @Input() set lifestyle(value: any) {
    this.loadLifestyle(value);
  }

  @Input() set personquantity(value: number) {
    if (!value) return;
    this.persons.setValue(value)
  }
  @Input() set recipequantity(value: number) {
    if (!value) return;
    this.meals.setValue(value)
  }

  scrollStrategy: ScrollStrategy;

  dateToday = formatDate(new Date(), 'yyyy-MM-dd', ɵDEFAULT_LOCALE_ID);
  dateNextWeek = formatDate( this._globalService.addDays(new Date(),8 ) , 'yyyy-MM-dd', ɵDEFAULT_LOCALE_ID);
  activeWeek = "current";

  persons = this._subscriptionService.flowdefaultpersons;
  meals = this._subscriptionService.flowdefaultrecipes;

  @ViewChild('bottomdrawer', { static: true }) bottomdrawer: TemplateRef<any>
  @ViewChild('lifestylechosendialog') lifestylechosendialog: LifestylechosendialogComponent;

  imageRecipes: Recipe[] = [];
  overlaycomponent: OverlayComponent

  constructor(
    public activatedRoute: ActivatedRoute,
    public authService: AuthService,
    public _globalService: GlobalService,
    private _modalService: NgbModal,
    public drawerService: DrawerService,
    private _subscriptionService: SubscriptionService,
    private _sso: ScrollStrategyOptions,
    private _customerService: CustomerService,
    @Inject(PLATFORM_ID) private platformId: any,
  ) {

  }

  unsubscribe = new Subject<void>();

  ngOnInit() {
    this.scrollStrategy = this._sso.noop();

    this.drawerService.setDrawer(Drawerposition.bottom, this.bottomdrawer, DrawerIdentifier.lifestyleBottomDrawer, ' md:w-[500px] mx-auto h-auto', false, true);
    // this.openBottomsheet();
  }

  ngOnDestroy() {
    this.closeBottomsheet();
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  loadLifestyle(value: any) {
    this._lifestyle = value;

    setTimeout(() => {
      this.openBottomsheet();
    }, 1500);
  }

  changePersonQty(qty: number) {
    this.persons.setValue(qty);
    this.setSubscriptionObject();
  }

  changeMealQty(qty) {
    this.meals.setValue(qty);
    this.setSubscriptionObject();

  }

  chooseLifestyle() {
    this.setSubscriptionObject();
    this.closeBottomsheet();
    this.lifestylechosendialog.navigateToPersonalmenu(this.meals.value, this.persons.value, this._lifestyle)
  }

  setSubscriptionObject() {
    if(!!this.authService.isAuthenticatedValue) return;
    this._customerService.getCustomerLifestyles.clear();
    this._customerService.getCustomerFlowLifestyles.clear();
    this._customerService.addLifeStyle(new CustomerLifestyle(null, this._lifestyle.id))
  }

  showRecipe(recipe: Recipe, persons: number) {
    const dialog = this._modalService.open(OverlayComponent, { modalDialogClass: 'w-[97%] max-w-7xl h-[95%] rounded-lg' });
    this.overlaycomponent = dialog.componentInstance;
    this.overlaycomponent.modal = dialog;
    this.overlaycomponent = dialog.componentInstance;

    this.overlaycomponent.innerComponent = RecipeComponent

    this.overlaycomponent.createdComponent.pipe(takeUntil(this.unsubscribe)).subscribe((res: RecipeComponent) => {
      res.recipe = recipe;
      res.personquantity = persons
    })
  }

  setImageRecipes(recipes: Recipe[]) {
    if (!recipes) { return; }
    setTimeout(() => {
      this.imageRecipes = recipes.slice(0, 3);
    });

  }

  openBottomsheet() {
    if (!isPlatformBrowser(this.platformId)) return;
    // console.log('authenticated', this.authService.isAuthenticated);
    if(!!this.authService.isAuthenticatedValue) return;

    let drawer = this.drawerService.open(DrawerIdentifier.lifestyleBottomDrawer);
    if (drawer)
      drawer.dismissed.pipe(takeUntil(this.unsubscribe)).subscribe(() => {
        setTimeout(() => {
          this.closeBottomsheet();
        });
      })
  }
  closeBottomsheet() {
    this.drawerService.close(DrawerIdentifier.lifestyleBottomDrawer);
  }




}
